<template>
    <div>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">

            <a-form-item label="审核状态">
                <a-select show-search v-model="searchP.auditstate" placeholder="选择状态"  allow-clear style="width: 150px">
                    <a-select-option v-for="d in statelist" :key="d.value">
                        {{ d.label }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                auditstate:'02',
            },
            statelist:[
                //01-未审核 02-审核中 03-审核成功  04-审核失败
                {
                    label:'全部',
                    value:''
                },
                {
                    label:'未审核',
                    value:'01'
                },
                {
                    label:'审核中',
                    value:'02'
                },
                {
                    label:'审核成功',
                    value:'03'
                },
                {
                    label:'审核失败',
                    value:'04'
                },
            ]
        }
    },
    methods:{
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        }
      
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

